import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab9',
  templateUrl: './awsop-lab9.component.html',
  styleUrls: ['./awsop-lab9.component.css']
})
export class AwsopLab9Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab9/awsop-lab9.component.ts